import React, { Component, Fragment } from 'react';
import Button from 'material-ui/Button';
import TextField from 'material-ui/TextField';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from 'material-ui/Dialog';

class FormDialog extends Component {
  constructor(props) {
    super(props);

    this.state = { open: false, nameValue: '', numberValue: null };
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleSubmit = () => {
    this.setState({ open: false });
    if (this.props.onSubmit) {
      this.props.onSubmit(this.state.nameValue, this.state.numberValue);
    }
  }

  handleNameChange = e => {
    this.setState({ nameValue: e.target.value });
  }

  handleNumberChange = e => {
    this.setState({ numberValue: e.target.value });
  }

  render() {
    return (
      <Fragment>
        <Button variant="raised" color="primary" onClick={this.handleClickOpen}>{this.props.buttonText}</Button>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">{this.props.buttonText}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Enter the details for the {this.props.buttonText.split(' ')[1]} you wish to add.
            </DialogContentText>
            <TextField
              autoFocus
              required
              margin="dense"
              id="name"
              label="Name"
              type="text"
              fullWidth
              onChange={this.handleNameChange}
            />
            {(this.props.buttonText.split(' ')[1] === "Player") && <TextField
              required
              margin="dense"
              id="number"
              label="Number"
              type="number"
              fullWidth
              onChange={this.handleNumberChange}
            />}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleSubmit} color="primary">
              {this.props.buttonText}
            </Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

export default FormDialog;



// WEBPACK FOOTER //
// ./src/FormDialog.jsx